import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['button', 'popover']

  initialize() {
    this.boundCloseHandleEvent = this.closeHandleEvent.bind(this);
  }

  connect() {
    this.element[this.identifier] = this
    document.addEventListener("click", this.boundCloseHandleEvent, true)
  }

  disconnect() {
    this.close()
    document.removeEventListener("click", this.boundCloseHandleEvent, true)
  }

  close(event) {
    if (this.hasPopoverTarget) {
      this.buttonTargets.forEach((el) => {
        el.classList.remove('is-active')
        el.removeAttribute('data-current-popper-target')
      })
      this.popoverTarget.querySelector('div[data-popper-arrow]').remove()
      this.popoverTarget.style.display = 'none'
      this.popoverTarget.removeAttribute('data-current-popper-target')
    }
  }

  closeHandleEvent(event) {
    var matches = function(el, selector) {
      return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector)
    }

    if (!matches(event.target, "[data-popper-target~='button'], [data-popper-target~='button'] *, [data-popper-target~='popover'], [data-popper-target~='popover'] *, .flatpickr-calendar *")) {
      this.close()
    }
  }
}
